import { render, staticRenderFns } from "./MeetingDetails.vue?vue&type=template&id=28ea799b"
import script from "./MeetingDetails.vue?vue&type=script&lang=js"
export * from "./MeetingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports